import {BaseApi} from './base-api';
import Vue from 'vue';

export class NotificationApi extends BaseApi {
  static apiUri = 'notifications';

  /** @return {Promise<PagedHttpResponse<NotificationDto>>} */
  static getAll () {
    return super.getAll();
  }

  /** @return {Promise<EntityHttpResponse<NotificationDto>>} */
  static getById (id) {
    return super.getById(id);
  }

  /** @return {Promise<PagedHttpResponse<NotificationDto>>} */
  static getActiveNotifications () {
    return Vue.http.get(this.apiUri + '/active');
  }

  /**
   * @param {string} notificationId
   * @param {NotificationUpdateRequest} notificationUpdateRequest
   * @return {Promise<EntityHttpResponse<NotificationDto>>}
   */
  static updateNotification (notificationId, notificationUpdateRequest) {
    return Vue.http.post(this.apiUri + '/' + notificationId, notificationUpdateRequest);
  }
}
